<template>
    <div>
        <div class="tabContent" v-if='showFlag'>
            <el-tabs @tab-click="handleClick" v-model='activeName'>
                <el-tab-pane :label="$translate('lang.E3202103030013', { defaultText: '产品信息' })" name="first">
                    <div class="messageContent">
                        <el-row class="commomPaper proBase">
                            <el-col :span='8' v-for='(item, index) in productInformation' :key='index' class="totalText" style="display: flex;">
                                <div class="label" :title='item.label'>
                                    <span class="labelText">{{item.label}}</span>
                                </div>
                                    <el-tooltip effect="dark" :content="item.value" placement="top" v-if='item.value.length > 33'>
                                        <div class="valueText">{{item.value}}</div>
                                    </el-tooltip>
                                    <div class="valueText" v-else>{{item.value}}</div>
                            </el-col>
                        </el-row>
                        <el-row class="commomPaper base2Total">
                            <el-col :span='12' class="base2Size">
                                <el-row>
                                    <el-col :span='8' class='proBase2' v-for='(item, index) in productFunctionAndSize.slice(0, 9)' :key='index'>
                                        <div class="itemRow2">
                                            <el-tooltip effect="dark" :content="item.value" placement="top" v-if='item.value.length > 11'>
                                                <span class="valueText unitValueText">{{item.value}}</span>
                                            </el-tooltip>
                                            <span class="valueText unitValueText" v-else>{{item.value}}</span>
                                        </div>
                                        <div class="itemRow2">
                                            <span class="labelText">{{item.label}}</span>
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-col>
                            <el-col :span='12' class="base2Size">
                                <div style="position: relative;">
                                    <img src="../../../../assets/images/speciflcation.png" alt="">
                                    <div v-for="(item, index) in productFunctionAndSize.slice(9, 14)"
                                    :key='index'
                                    :style="{'position': 'absolute', top: item.top, left: item.left, 'min-width': '80px'}">
                                        <div>
                                            <span class="valueText unitValueText">{{item.value}}</span>
                                        </div>
                                        <div>
                                            <span class="labelText">{{item.label}}</span>
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </el-tab-pane>
                <el-tab-pane :label="$translate('lang.E3202103030014', { defaultText: '产品说明书' })" name="second">
                    <div v-if='!proIframeSrc' class="imgContent">
                        <img src="../../../../assets/images/blank.png" width="88" height="82" alt="" class="commomImg">
                        <p class="commomImgText">{{$translate('lang.E3202103030115', { defaultText: '该产品暂无说明书。' })}}</p>
                    </div>
                    <iframe v-else
                    :src="proIframeSrc" frameborder="0"></iframe>
                </el-tab-pane>
                <el-tab-pane :label="$translate('lang.E3202103030015', { defaultText: '产品图片' })" name="third">
                    <div class="demo-image__preview">
                        <div v-if='srcList.length < 1' class="imgContent">
                            <img src="../../../../assets/images/blank.png" width="88" height="82" alt="" class="commomImg">
                            <p class="commomImgText">{{$translate('lang.E3202103030116', { defaultText: '该产品暂无图片。' })}}</p>
                        </div>
                        <el-image
                          v-else
                          class="elImage"
                          v-for="(item,index) in srcList"
                          :key="index"
                          :src="item.imagePath"
                          :preview-src-list="srcListView">
                        </el-image>
                      </div>
                </el-tab-pane>
                <el-tab-pane :label="$translate('lang.E3202103030016', { defaultText: '产品视频' })" name="fourth">
                    <div class="videoContent">
                        <div v-if='!videoSrc'>
                            <img src="../../../../assets/images/blank.png" width="88" height="82" alt="" class="commomImg">
                            <p class="commomImgText">{{$translate('lang.E3202103030117', { defaultText: '该产品暂无视频。' })}}</p>
                        </div>
                        <video controls v-else class="videoPlay">
                            <source
                              :src="videoSrc"
                              :type='videoType'>
                          </video>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
        <div v-else class="blankContent">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane :label="$translate('lang.E3202103030013', { defaultText: '产品信息' })" name="first"></el-tab-pane>
                <el-tab-pane :label="$translate('lang.E3202103030014', { defaultText: '产品说明书' })" name="second"></el-tab-pane>
                <el-tab-pane :label="$translate('lang.E3202103030015', { defaultText: '产品图片' })" name="third"></el-tab-pane>
                <el-tab-pane :label="$translate('lang.E3202103030016', { defaultText: '产品视频' })" name="fourth"></el-tab-pane>
            </el-tabs>
            <img src="../../../../assets/images/blank.png" width="88" height="82" alt="">
            <p class="imgText">{{$translate('lang.E3202103030017', { defaultText: '暂无数据， 请在条码号处输入搜索' })}}</p>
        </div>
    </div>
</template>
<script>
import { productInformation, productFunctionAndSize } from './js/proMessage.js';
import { searchPro } from '../../../../api/productProcess.js';
export default {
    props: {
        proMessageObj: {
            type: Object,
            default: () => {}
        },
        proNum: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            activeName: 'first',
            srcList: [],
            srcListView: [],
            videoFlag: true,
            imgFlag: true,
            instructionsFlag: true,
            productInformation,
            productFunctionAndSize,
            proIframeSrc: '',
            videoSrc: '',
            videoType: '',
            showFlag: false
        };
    },
    methods: {
        handleClick(tab, event) {
        },
        initData() {
            this.productInformation.forEach(item => {
                item.value = '';
            });
            this.productFunctionAndSize.forEach(item => {
                item.value = '';
            });
            this.srcList = [];
            this.srcListView = [];
            this.proIframeSrc = '';
            this.videoSrc = '';
            this.videoType = '';
        },
        initTabDefault() {
            this.activeName = 'first';
        },
        setproNum(proNum) {
            if (!proNum) {
                this.initTabDefault();
                this.showFlag = false;
                return;
            }
            this.initData();
            searchPro(proNum).then(res => {
                if (res.code === '0' && res.data) {
                    this.$emit('setIndex', false);
                    this.showFlag = true;
                    // 渲染信息页上部分
                    const { product, productImageList, productVideoList, pproductBathList } = res.data;
                    const keys = Object.keys(product);
                    this.productInformation.forEach(item => {
                        keys.map(item2 => {
                            if (item.key === item2) {
                                item.value = product[item2];
                            }
                        });
                    });
                    // 渲染信息页下部分
                    this.productFunctionAndSize.forEach(item => {
                        keys.map(item2 => {
                            if (item.key === item2) {
                                item.value = product[item2];
                            }
                        });
                    });
                    // 渲染图片页
                    this.srcList = productImageList.sort(this.compare('seqno'));
                    this.srcListView = this.srcList.map(item => {
                        return item.imagePath;
                    });
                    // 渲染说明书
                    if (pproductBathList.length > 0) {
                        this.proIframeSrc = pproductBathList[0].docMainContentPath;
                    }
                    // 渲染视频
                    if (productVideoList.length > 0) {
                        this.videoSrc = productVideoList[0].videoPath;
                        this.videoType = 'video/' + productVideoList[0].videoType;
                    }
                }
            }).catch(() => {
                this.$emit('setIndex', true);
                this.showFlag = false;
            });
            this.initTabDefault();
        },
        compare(prop) { // 根据seqno进行图片按序号排序
            return function(a, b) {
                var value1 = a[prop];
                var value2 = b[prop];
                return value1 - value2;
            };
        }
    }
};
</script>
<style lang="less">
@import './style/imageViewer.less';
@import './style/proMessage.less';
</style>